export default __webpack_public_path__ + "static/media/admin-step2.88676bd2.gif";